import { render } from "./RecipientSelector.vue?vue&type=template&id=b95144b8&scoped=true&ts=true"
import script from "./RecipientSelector.vue?vue&type=script&lang=ts"
export * from "./RecipientSelector.vue?vue&type=script&lang=ts"

import "./RecipientSelector.vue?vue&type=style&index=0&id=b95144b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95144b8"]])

export default __exports__